import React, { useState } from "react";
import Filter from "./Filter";
import Table from "./Table";
import './Roles.css'
import Add_Role from "./Add_Role";
import Edit_Role from "./Edit_Role";

const Roles = () => {
  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);

  return (
    <section className="Roles">
     
      <div className="filter_div">
        <Filter setAdd={setAdd}/>
      </div>

      <div className="sample_table_div">
        <Table setEdit={setEdit}/>
      </div>

      <Add_Role show={add} setShow={setAdd} handleClose={() => {setAdd(false)}} />
      <Edit_Role show={edit} setShow={setEdit} handleClose={() => {setEdit(false)}} />
   
    </section>
  );
};

export default Roles;
